<template>
  <div>
    <div class="container">
      <ShadowTitle :title="`Как было на прошлом мероприятии`"
                   title-shadow="EVENTS"
      />
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-9">
          <div class="youtube-video-container">
            <div class="youtube-video-poster" v-if="!videoLoaded">
              <div class="youtube-video-image"/>
              <div class="youtube-video-play" @click="loadVideo"/>
            </div>
            <iframe v-else
                    class="youtube-video-iframe"
                    v-show="true"
                    :src="videoUrl"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
            >
            </iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="gallery d-none d-lg-block">
      <div class="row g-2">
        <div class="col-12 col-md-6">
          <div class="row g-2">
            <div class="col-12">
              <img class="img-fluid" :src="require(`@/assets/gallery/gallery-1.png`)">
            </div>
            <div class="col-6">
              <img class="img-fluid" :src="require(`@/assets/gallery/gallery-2.png`)">
            </div>
            <div class="col-6">
              <img class="img-fluid" :src="require(`@/assets/gallery/gallery-3.png`)">
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row g-2">
            <div class="col-6">
              <img class="img-fluid" :src="require(`@/assets/gallery/gallery-4.png`)">
            </div>
            <div class="col-6">
              <div class="row g-2">
                <div class="col-12">
                  <img class="img-fluid" :src="require(`@/assets/gallery/gallery-5.png`)">
                </div>
                <div class="col-12">
                  <img class="img-fluid" :src="require(`@/assets/gallery/gallery-6.png`)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gallery-slider d-block d-lg-none">
      <div class="container">
        <div class="swiper-container swiper-galley">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img :src="require(`@/assets/gallery/gallery-mob-1.png`)">
            </div>
            <div class="swiper-slide">
              <img :src="require(`@/assets/gallery/gallery-mob-2.png`)">
            </div>
            <div class="swiper-slide">
              <img :src="require(`@/assets/gallery/gallery-mob-3.png`)">
            </div>
            <div class="swiper-slide">
              <img :src="require(`@/assets/gallery/gallery-mob-4.png`)">
            </div>
            <div class="swiper-slide">
              <img :src="require(`@/assets/gallery/gallery-mob-5.png`)">
            </div>
            <div class="swiper-slide">
              <img :src="require(`@/assets/gallery/gallery-mob-6.png`)">
            </div>
          </div>
          <div class="swiper-pagination swiper-galley-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted, ref} from "vue";
import Swiper from "swiper";
import {Pagination} from 'swiper/modules';
import 'swiper/swiper.css';

import ShadowTitle from "@/components/ShadowTitle";

export default {
  name: "Gallery",
  components: {ShadowTitle},
  setup() {
    const swiperInstance = ref(null);
    const videoLoaded = ref(false);
    const videoUrl = 'https://www.youtube.com/embed/mF1FEoS02ao?si=wRfXGSStdNI4-URT';

    const loadVideo = () => {
      videoLoaded.value = true;
    };

    const initializeSwiper = () => {
      swiperInstance.value = new Swiper('.swiper-galley', {
        modules: [Pagination],
        pagination: {
          el: '.swiper-galley-pagination',
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 16
          },
          400: {
            slidesPerView: 1.5,
            spaceBetween: 16
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16
          }
        }
      });
    }

    onMounted(() => {
      initializeSwiper();
    })

    return {
      videoLoaded,
      videoUrl,
      loadVideo,

    }
  },
}
</script>

<style lang="scss" scoped>
.youtube-video-container {
  position: relative;
  border-radius: 16px;
  height: 386px;
  overflow: hidden;
  margin-bottom: 18px;
  @include _768 {
    height: 510px;
    margin-bottom: 76px;
  }
}

.youtube-video-image {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: url(~@/assets/gallery/poster-2.png) no-repeat center;
  background-size: cover;
  @include _768 {
    background: url(~@/assets/gallery/poster-2.png) no-repeat center;
    background-size: cover;
  }
}

.youtube-video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
}

.youtube-video-poster {
  position: relative;
  width: 100%;
  height: 100%;

  .youtube-video-play {
    width: 56px;
    height: 56px;
    background: url(~@/assets/video-play.svg) no-repeat center;
    background-size: contain;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    @include _768 {
      width: 76px;
      height: 76px;
    }
  }
}

.gallery {
  div {
    display: flex;
  }

  img {
    border-radius: 16px;
  }
}

.gallery-slider {
  .swiper-slide {
    img {
      width: 100%;
      border-radius: 16px;
    }
  }
}
</style>